/**
 * Message lisible d'un refus de l'API catalogue : `{ error: "…" }`,
 * `{ errors: ["…"] }` ou `{ errors: { champ: ["…"] } }`. `null` quand la
 * réponse n'en porte pas, pour laisser l'appelant choisir son message.
 */
export const apiErrorMessage = (err: unknown): string | null => {
  const data = (err as { response?: { data?: { error?: unknown, errors?: unknown } } }).response?.data;
  if (!data) return null;
  if (typeof data.error === "string" && data.error.trim()) return data.error;
  const { errors } = data;
  if (Array.isArray(errors)) {
    const messages = errors.filter((e): e is string => typeof e === "string");
    return messages.length > 0 ? messages.join(", ") : null;
  }
  if (errors && typeof errors === "object") {
    const messages = Object.values(errors as Record<string, unknown>)
      .flatMap((v) => (Array.isArray(v) ? v : [v]))
      .filter((e): e is string => typeof e === "string");
    return messages.length > 0 ? messages.join(", ") : null;
  }
  return null;
};
